/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


jQuery(document).ready(function() {
  jQuery(".all_category_row .category_custom_toggle").click(function() {
    jQuery(".all_category_row .nav-bar__linklist").toggle();
  });
});



 jQuery(".acc_card:first-child .acc_title").addClass("active");
  jQuery(".acc_card:first-child .acc_panel").addClass("active");

  jQuery(".acc_title").click(function() {
    jQuery(".acc_title").not(this).removeClass("active"); // Remove active class from other titles
    jQuery(".acc_panel").removeClass("active"); // Remove active class from all panels

    jQuery(this).toggleClass("active");
    jQuery(this).siblings(".acc_panel").toggleClass("active");
  });

jQuery(document).ready(function($){
jQuery('.section.custom_logo_slider .quick-links ul').addClass('owl-carousel');
jQuery('.section.custom_logo_slider .quick-links ul').owlCarousel({
	loop:false,
	nav:true,
	dots:false,
	responsive:{
		0:{
			items:3
		},
		421:{
			items:3
		},
		600:{
			items:3
		},
		800:{
			items:4
		},
		1000:{
			items:5
			}
		  }
		})
	});


jQuery(document).ready(function($){
jQuery('.section.custom_blog_row .block-list').addClass('owl-carousel');
jQuery('.section.custom_blog_row .block-list').owlCarousel({
	loop:false,
	nav:true,
    margin: 25,
	dots:false,
	responsive:{
		0:{
			items:2,
          margin: 20
		},
		421:{
			items:2,
          margin: 20
		},
		600:{
			items:2,
          margin: 20
		},
		800:{
			items:3,
          margin: 20
		},
		1000:{
			items:4,
            margin: 20
			}
		  }
		})
	});

var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 500);
  }
};
var minWidth = 768;
function executeOnMinWidth() {
  if (window.innerWidth >= minWidth) {
    waitForEl('.all_collection_list_row .collection_list_row .collection-list-items .item', function() {
      var divs = jQuery(".all_collection_list_row .collection_list_row .collection-list-items .item");
      for (var i = 0; i < divs.length; i += 2) {
        divs.slice(i, i + 2).wrapAll("<div class='wrap'></div>");
      }
    });
  }
}
executeOnMinWidth();
window.addEventListener('resize', executeOnMinWidth);

jQuery(document).ready(function($){
  jQuery('.all_collection_list_row .collection_list_row .collection-list-items').addClass('owl-carousel');
  jQuery('.all_collection_list_row .collection_list_row .collection-list-items').owlCarousel({
    loop:false,
    nav:true,
    margin:15,
    dots:false,
    responsive:{
        0:{
            items:2,
        },
        768:{
            items:2
        },
        1000:{
            items:3
            }
          }
     })
});



jQuery(document).ready(function($) {
  function executeOnMaxWidth() {
    if (window.innerWidth <= 767) {
      jQuery('.section.custom_mosaic_row .mosaic.mosaic_medium.mosaic_three_columns.show_mobile .mosaic__column').addClass('owl-carousel');
      jQuery('.section.custom_mosaic_row .mosaic.mosaic_medium.mosaic_three_columns.show_mobile .mosaic__column').owlCarousel({
        loop: false,
        nav: false,
        margin: 15,
        stagePadding: 40,
        dots: false,
        mouseDrag: true,
        touchDrag: true,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 1
          }
        }
      });
    }
  }

  // Execute initially and on window resize
  executeOnMaxWidth();
  jQuery(window).on('resize', executeOnMaxWidth);
});